import React from 'react';
import { NavLink as RouterLink } from 'react-router';

import styled from '@emotion/styled';

export const NavLink = styled(RouterLink)`
  text-decoration: none;
  color: black;
  font-weight: 500;
  display: flex;
  gap: 0.5rem;

  &.footer {
    font-weight: 600;
  }

  &.hamburger-menu {
    font-size: 1rem;
    font-weight: 600;
    color: black;
  }
`;

interface IExternalLink {
  children: React.ReactNode;
  to: string;
  className?: string;
}

export const ExternalLink: React.FC<IExternalLink> = ({
  children,
  to,
  className,
}) => {
  return (
    <AnchorTag
      href={to}
      target='_blank'
      rel='noopener noreferrer'
      className={className}
    >
      {children}
    </AnchorTag>
  );
};

export const AnchorTag = styled.a`
  text-decoration: none;
  font-weight: 500;

  &.footer {
    display: grid;
    grid-template-columns: 1.5rem auto;
    gap: 0.5rem;
    font-weight: 600;
  }

  &.header_nav__mobile {
    @media (max-width: 480px) {
      display: None;
    }
  }
`;

export const ButtonLink = styled(RouterLink)`
  text-decoration: none;
  font-weight: 500;
`;

interface INavItem {
  icon: React.ReactNode;
  children: string;
  path: string;
}

export const NavBoxItem: React.FC<INavItem> = ({ icon, path, children }) => {
  return (
    <NavigationBoxLink
      className={(navData) => (navData.isActive ? 'active' : '')}
      to={path}
    >
      {icon}
      {children}
      <div className='v-line'></div>
    </NavigationBoxLink>
  );
};

export const NavigationBoxLink = styled(RouterLink)`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.logirateBlack};
  display: flex;
  gap: 7px;

  padding: 0px 24px;
  height: 36px;
  padding-right: 0px;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  display: flex;
  align-items: center;

  &:hover {
    background-color: white;
  }

  &.active {
    background-color: white;
    font-weight: 700;
    & svg {
      color: ${({ theme }) => theme.palette.logirateBlack};
    }

    & div.v-line {
      width: 4.17px;
      height: 100%;
      border-radius: 25px;

      background-color: ${({ theme }) => theme.palette.blueColor};
      margin-left: auto;
    }
  }
`;

export const InternalNavLink = styled(RouterLink)`
  text-decoration: none;
  color: ${({ theme }) => theme.palette.navLinkColor};
  font-weight: 600;
  color: ${({ theme }) => theme.palette.navLinkColor};

  &:hover {
    color: ${({ theme }) => theme.palette.lightOverlay} !important;
  }

  &.footer {
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.875rem;
    font-weight: 400;
  }

  &.hamburger {
    color: ${({ theme }) => theme.palette.navLinkColor};
    font-size: 1rem;
    font-weight: 600;
  }
`;
